import { useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { MdArrowDropDown, MdClose } from "react-icons/md";

import Description from "../Description/Description";

import "./FamilyAccordion.css";

interface Props {
  title: string;
  description: string;
  className?: string;
}

const FamilyAccordion = (props: Props) => {
  const [clicked, setClicked] = useState(false);

  return (
    <Accordion>
      <Card
        className={`family-accordion border-left-0 border-right-0 p-2 ${props.className}`}
      >
        <Card.Body className="p-0" onClick={() => setClicked(!clicked)}>
          <Accordion.Toggle
            eventKey="0"
            className="border-0 p-0 bg-transparent w-100 text-left"
          >
            <span className="family-accordion-title">{props.title}</span>

            {clicked ? (
              <MdClose className="family-accordion-icon" />
            ) : (
              <MdArrowDropDown className="family-accordion-icon" />
            )}
          </Accordion.Toggle>
        </Card.Body>
        <Accordion.Collapse eventKey="0">
          <Card.Body className="pl-0 pb-0 pt-0 mt-3">
            <Description
              text={props.description}
              className="family-accordion-text"
            />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default FamilyAccordion;
